export default __webpack_public_path__ + "static/media/Logo-small.3b6a6934.svg";